/**
 * useCookie Hook
 * @module useCookie
 */

const MAX_LENGTH = 4000;

/**
 * @function
 * Get getAllCookies will return an object containing all the cookies.
 * @returns {string} - object
 */
export const getAllCookies = () => {
  const cookies = {};
  if (typeof document !== 'undefined') {
    const cookieData = document?.cookie?.split('; ');
    cookieData?.forEach(accumulator => {
      const [key, value] = accumulator.split('=');
      cookies[key.toUpperCase()] = value;
    });
    return cookies;
  }
  return null;
};

/**
 * @function
 * Retrieve filtered cookie by its name
 * @param {string} cookieName - attribute name
 * @returns {void} - attribute value
 */

export const getFilteredCookieName = (cookieName, cookies) => {
  let filteredCookieName;
  if (cookies) {
    filteredCookieName = Object?.keys(cookies)?.find(ele =>
      ele.toLowerCase().endsWith(cookieName.toLowerCase())
    );
  } else filteredCookieName = null;
  return filteredCookieName;
};

/**
 * @function
 * Retrieve specific cookie by its name
 * @param {string} cookieName - attribute name
 * @returns {void} - attribute value
 */

export const getCookie = cookieName => {
  const cookies = getAllCookies();
  const filteredCookieName = getFilteredCookieName(cookieName, cookies);
  if (filteredCookieName) return cookies[filteredCookieName];
  return null;
};

/**
 * @function
 * Set item in cookie
 * @param {string} cookieName - attribute name
 * @param {string} cookieValue - attribute value
 * @param {string} expiry - attribute expiry time (string of date in UTC format)
 * @returns {void} - attribute value
 */

export const setCookie = (CODE, cookieName, cookieValue, expiry) => {
  const expires = new Date(expiry).toUTCString();
  if (typeof document !== 'undefined') {
    document.cookie = expires
      ? `${CODE}_${cookieName.toUpperCase()}=${cookieValue};  expires=${expires};  domain=.eir.ie; path=/`
      : `${CODE}_${cookieName.toUpperCase()}=${cookieValue};  domain=.eir.ie; path=/`;
    if (expiry && !expires) {
      console.error('Error setting  cookie with expiry');
    }
  }
};

/**
 * @function
 * Clears all the cookies with prefix (Prefix includes CO/CS)
 * @param {string} prefix - attribute name
 * @returns {void} - attribute value
 */
export const clearCookies = CODE => {
  const cookies = document?.cookie.split(';');

  for (let i = 0; i < cookies?.length; i += 1) {
    const cookie = cookies[i]?.trim();

    if (cookie?.startsWith(CODE)) {
      const cookieName = cookie.split('=')[0];
      document.cookie = `${cookieName.toUpperCase()}=;expires=${new Date(
        0
      ).toUTCString()}; domain=.eir.ie; path=/`;
    }
  }
};

/**
 * @function
 * Removes a particular cookie
 * @param {string} cookieName - attribute name
 * @returns {void} - attribute value
 */
export const removeCookie = cookieName => {
  const cookies = getAllCookies();
  const filteredCookieName = getFilteredCookieName(cookieName, cookies);
  if (typeof document !== 'undefined') {
    document.cookie = `${filteredCookieName}=;expires=${new Date(
      0
    ).toUTCString()}; domain=.eir.ie; path=/`;
  }
};
/**
 * @function
 * Removes a particular R6 cookie
 * @param {string} cookieName - attribute name
 * @returns {void} - attribute value
 */
export const deleteCookie = cookieName => {
  if (typeof document !== 'undefined') {
    document.cookie = `${cookieName}=; path=/`;
  }
};

export const setTokenInCookies = async (token, expiry) => {
  const loops = Math.ceil(token.length / MAX_LENGTH);
  let i = 0;
  // const tokens = [];
  return (function splitToken(subToken) {
    if (subToken !== '')
      setCookie('ION', `token_${i}`.toUpperCase(), subToken.slice(0, MAX_LENGTH), expiry);
    // if (subToken !== '') tokens.push(subToken.slice(0, MAX_LENGTH));
    if (i > loops) return;
    i += 1;
    //   setCookie('token', subToken.slice(0, MAX_LENGTH), expiry);
    splitToken(subToken.slice(MAX_LENGTH), MAX_LENGTH);
  })(token);
};

export const getTokenFromCookies = (cookieObj = undefined) => {
  const allCookies = cookieObj || getAllCookies();
  const token = Object.keys(allCookies || '{}')
    .filter(key => key.indexOf('ION_TOKEN') === 0)
    .sort()
    .reduce((tokenChunk, next) => tokenChunk + allCookies[next], '');
  return token;
};

/**
 * @function
 * Clears all the cookies
 * @returns {void} - attribute value
 */

export const clearAllCookies = () => {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i];
    const pos = cookie.indexOf('=');
    const cookieName = pos > -1 ? cookie.substr(0, pos) : cookie;
    document.cookie = `${cookieName.toUpperCase()}=;expires=${new Date(
      0
    ).toUTCString()}; domain=.eir.ie; path=/`;
  }
};
/**
 * @function
 * Hook to get cookie,set cookie,clear and remove cookie
 * @returns - { getAllCookies, getCookie, setCookie, clearCookies,clearAllCookies, removeCookie}
 */
export default function useCookie() {
  return {
    getAllCookies,
    getCookie,
    setCookie,
    clearCookies,
    clearAllCookies,
    removeCookie,
    setTokenInCookies,
  };
}
